import { InquiryPeriod } from "../../store/inquiries/types";
import usePeriods from "../common/usePeriods";

export default function useJälkitilitPeriods(): InquiryPeriod[] {
  return usePeriods("jälkitilit");
}
